// extracted by mini-css-extract-plugin
export default {"banner":"SubBanner_banner__Ci-o8"};